import { useEffect, useState } from "preact/hooks";
import type { InstallRunner } from "../flow/runner";
import { t } from "../i18n";
import type { RingLogger } from "../logs/ring";

export function LogsPanel({ log, runner }: { log: RingLogger; runner: InstallRunner }) {
  const [n, setN] = useState(log.snapshot().length);
  const [ticket, setTicket] = useState<string | undefined>();
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    const fn = () => setN(log.snapshot().length);
    log.listeners.add(fn);
    return () => void log.listeners.delete(fn);
  }, [log]);
  const download = () => {
    const blob = new Blob([log.toJsonl()], { type: "application/x-ndjson" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `qh-installer-${log.sessionId}.jsonl`;
    a.click();
    setTimeout(() => URL.revokeObjectURL(a.href), 1000);
  };
  const upload = async () => {
    setBusy(true);
    setTicket(await runner.uploadLogs(navigator.userAgent));
    setBusy(false);
  };
  const tail = log.snapshot().slice(-30);
  return (
    <details class="logs panel">
      <summary>{t("logs.heading")} — {t("logs.entries", { n })}</summary>
      <p class="hint">{t("logs.session", { id: log.sessionId })}</p>
      <div class="row">
        <button type="button" onClick={download}>{t("logs.download")}</button>
        <button type="button" onClick={() => void upload()} disabled={busy}>{t("logs.upload")}</button>
        {ticket && <span role="status">{t("logs.uploaded", { ticket })}</span>}
      </div>
      <pre class="logbox" tabIndex={0}>{tail.map((e) => JSON.stringify(e)).join("\n")}</pre>
    </details>
  );
}
